<template>
  <vx-modal :title="$t('MODALS.originSelectTrigger.title')">
    <template v-slot:body>
      <div class="filtros flex justify-between items-center">
        <div class="flex w-1/2">
          <vs-select v-model="originKey" autocomplete class="selectExample w-full" @change="getColumns(originKey)">
            <vs-select-item
              :key="index"
              :value="item.key"
              :text="item.description"
              v-for="(item, index) in listOrigins"
            />
          </vs-select>
          <!-- <vs-button class="ml-2" color="success" type="border" icon-pack="feather" icon="icon-search"></vs-button> -->
        </div>
        <span>{{ $t("MODALS.originSelectTrigger.total") }} {{ total_register }}</span>
        <div class="filtro-2">
          <i class="vs-icon notranslate icon-scale vs-button--icon feather icon-grid null" style="font-size: 20px"></i>
        </div>
      </div>
      <div class="data w-full flex">
        <div class="fields pl-2 flex justify-between flex-col">
          <!-- {{columns}} -->
          <ul class="mt-2 w-full overflow-auto" style="height: 85%">
            <li v-for="(campo, index) in columns" :key="index" style="font-size: 13px">
              <vs-radio v-model="SelectedColumn" :vs-value="campo"
                ><span class="truncate inline-block" style="width: 120px">{{ campo }}</span></vs-radio
              >
            </li>
          </ul>
          <div class="flex items-center justify-center py-3">
            <vs-button color="success" type="border" @click="PreviweData()">{{
              $t("MODALS.originSelectTrigger.Preview")
            }}</vs-button>
          </div>
        </div>
        <div class="view-table">
          <div class="content-table">
            <table style="width: 100%">
              <thead>
                <tr>
                  <th style="min-width: 10px; padding: 6px 6px" v-if="SelectedColumn.length > 0">Item</th>
                  <th>{{ SelectedColumn }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in dataColumns" :key="index">
                  <td style="min-width: 12px; padding: 6px 6px; text-align: center">{{ index + 1 }}</td>
                  <td class="truncate">{{ item[SelectedColumn] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="config-choice p-3 relative">
          <p>
            {{ $t("MODALS.originChoice.messagge") }}
          </p>
          <div class="flex justify-center items-center px-5 mt-3 mb-5">
            <input-number
              v-model.number="cantRegister"
              :min="1"
              :max="total_register"
              @blur="reset($event)"
            ></input-number>
            <vs-button class="w-1/2" color="success" type="border" v-if="hasOptions === 0" @click="addItems()">{{
              $t("MODALS.originChoice.accept")
            }}</vs-button>
          </div>
          <div class="absolute bottom-0 px-5" v-if="hasOptions > 0">
            <span class="inline-block mb-5 font-bold">
              {{ $t("MODALS.originChoice.messagge2") }}
            </span>
            <div class="flex justify-between items-center mt-5 mb-3">
              <vs-button color="success" type="border" @click="addItems()">{{
                $t("MODALS.originChoice.add")
              }}</vs-button>
              <vs-button color="success" type="border" @click="replaceData()">{{
                $t("MODALS.originChoice.Replace")
              }}</vs-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </vx-modal>
</template>
<script type="text/javascript">
import { mapState, mapMutations } from "vuex";

import Api from "@/helpers/api.js";
import InputNumber from "../Number.vue";
export default {
  components: { InputNumber },
  data() {
    return {
      SelectedColumn: "",
      originKey: "",
      cantRegister: 20,
      columns: [],
      dataColumns: []
    };
  },
  watch: {
    activePopup: function (value) {
      if (!value) this.clearData();
    }
  },
  methods: {
    ...mapMutations("resource", ["UPDATE_STATE"]),
    getColumns(originKey) {
      if (originKey.trim().length > 0) {
        const columns = this.listOrigins.filter(origin => origin.key === originKey);
        this.columns = columns[0].columns;
      }
    },
    async PreviweData() {
      try {
        const result = await this.apiColumns(this.SelectedColumn, this.cantRegister);
        this.dataColumns = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    async addItems() {
      try {
        const result = await this.apiColumns(this.SelectedColumn, this.cantRegister);
        const array = result.data.map(item => item[this.SelectedColumn]);
        const joinArray = [...this.options, ...array];
        this.questionsByPage[this.indexQuestion].options = joinArray;
        this.UPDATE_STATE({ key: "activePopup", value: false });
      } catch (e) {
        console.log(e);
      }
    },
    async replaceData() {
      try {
        const result = await this.apiColumns(this.SelectedColumn, this.cantRegister);
        const array = result.data.map(item => item[this.SelectedColumn]);
        this.questionsByPage[this.indexQuestion].options = array;
        this.UPDATE_STATE({ key: "activePopup", value: false });
      } catch (e) {
        console.log(e);
      }
    },
    async apiColumns(SelectedHeaders, limit) {
      try {
        const data = {
          originID: this.originKey,
          columns: [this.SelectedColumn],
          limit: this.cantRegister
        };
        const result = await Api.post("/origins/columns", data);
        return result;
      } catch (e) {
        // statements
        console.log(e);
      } finally {
        // statements
      }
    },
    clearData() {
      this.SelectedColumn = "";
      this.originKey = "";
      this.cantRegister = 20;
      this.columns = [];
      this.dataColumns = [];
    },
    reset(event) {
      if (event > this.total_register) this.cantRegister = this.total_register;
    }
  },
  computed: {
    ...mapState("resource", ["listOrigins", "indexQuestion", "questionsByPage", "activePopup"]),
    options() {
      if (this.hasOptions === 0) return [];
      return this.question.options;
    },
    question() {
      return this.questionsByPage[this.indexQuestion];
    },
    hasOptions() {
      if (this.question) {
        const option = this.question.options[0];
        const tam = this.question.options.length;
        if (tam === 1) {
          if (option === "opción 1") return 0;
        }
        return tam;
      }

      return 0;
    },
    total_register() {
      if (this.originKey.trim().length > 0) {
        const totalRecords = this.listOrigins.filter(origin => origin.key === this.originKey)[0].totalRecords;
        return totalRecords;
      } else {
        return 0;
      }
    }
  }
};
</script>

<style type="text/css" scoped>
.filtros {
  border-bottom: 1px solid rgba(110, 110, 110, 0.2);
  padding: 20px;
}

.data {
  height: calc(502px - 79px);
  /*background: red;*/
}

.fields {
  /*background: blue;*/
  width: 25%;
  height: 100%;
  border-right: 1px solid rgba(110, 110, 110, 0.2);
}

.view-table {
  box-sizing: box-border;
  width: 35%;
  height: 100%;
  overflow: auto;
}

.config-choice {
  /*background: red;*/
  height: 100%;
  width: calc(100% - 35% - 25%);
}

.view-table .content-table {
  height: 100%;
  overflow: auto;
  border-right: 1px solid rgba(110, 110, 110, 0.2);
}

.view-table table {
  border-collapse: collapse;
  border: 1px solid rgb(110, 110, 110, 0.2);
}

.view-table table thead tr th,
.view-table table tbody tr td {
  border: 1px solid rgb(110, 110, 110, 0.2);
  min-width: 150px;
  height: 30px;
}

.view-table table tbody tr td {
  padding: 6px 10px;
  padding-top: 5px;
  padding-bottom: 3px;
}
</style>
